import { createContext, useContext, useState, useEffect, useCallback, type ReactNode } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface WaitlistCountContextType {
  count: number;
  refetch: () => Promise<void>;
}

const WaitlistCountContext = createContext<WaitlistCountContextType>({ count: 0, refetch: async () => {} });

export const WaitlistCountProvider = ({ children }: { children: ReactNode }) => {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    const { data, error } = await supabase.rpc('get_waitlist_count');
    if (!error && data !== null) setCount(data);
  }, []);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  return (
    <WaitlistCountContext.Provider value={{ count, refetch: fetchCount }}>
      {children}
    </WaitlistCountContext.Provider>
  );
};

export const useWaitlistCount = () => useContext(WaitlistCountContext);
